/**
 * @generated SignedSource<<523f2a043f283c1411f0397bff501a04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomFieldDefinitionModalQuery$variables = {
  customFieldId?: string | null;
  hasCustomFieldId: boolean;
};
export type CustomFieldDefinitionModalQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly company: {
      readonly " $fragmentSpreads": FragmentRefs<"CustomFieldDefinitionCreateModal_company" | "CustomFieldDefinitionEditModal_company">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"CustomFieldDefinitionEditModal_viewer">;
  } | null;
};
export type CustomFieldDefinitionModalQuery = {
  variables: CustomFieldDefinitionModalQuery$variables;
  response: CustomFieldDefinitionModalQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customFieldId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasCustomFieldId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "custom_field_definition_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"custom_field_definition_modal\")"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "customFieldId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "avaRef",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "readOnly",
        "storageKey": null
      }
    ],
    "type": "TextCustomField",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomFieldDefinitionModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CustomFieldDefinitionCreateModal_company"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CustomFieldDefinitionEditModal_company"
              }
            ],
            "storageKey": null
          },
          {
            "condition": "hasCustomFieldId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "FragmentSpread",
                "name": "CustomFieldDefinitionEditModal_viewer"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomFieldDefinitionModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "CustomFieldDefinitionV2TypeConnection",
                "kind": "LinkedField",
                "name": "customFieldDefinitionsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomFieldDefinitionV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "customFieldDefinitionsV2(first:1000)"
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_customFieldDefinitionsV2",
                "kind": "LinkedHandle",
                "name": "customFieldDefinitionsV2"
              }
            ],
            "storageKey": null
          },
          {
            "condition": "hasCustomFieldId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "customFieldDefinition",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ]
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d43589ad85f5b2e7530a7b48e0d64d5",
    "id": null,
    "metadata": {},
    "name": "CustomFieldDefinitionModalQuery",
    "operationKind": "query",
    "text": "query CustomFieldDefinitionModalQuery(\n  $customFieldId: ID\n  $hasCustomFieldId: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"custom_field_definition_modal\")\n    company {\n      ...CustomFieldDefinitionCreateModal_company\n      ...CustomFieldDefinitionEditModal_company\n      id\n    }\n    ...CustomFieldDefinitionEditModal_viewer_3HPvlA @include(if: $hasCustomFieldId)\n    id\n  }\n}\n\nfragment CustomFieldDefinitionCreateModal_company on Company {\n  id\n  customFieldDefinitionsV2(first: 1000) {\n    edges {\n      node {\n        __typename\n        id\n        key\n        type\n        displayName\n        entityType\n        avaRef\n        ... on TextCustomField {\n          readOnly\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CustomFieldDefinitionEditModal_company on Company {\n  id\n  customFieldDefinitionsV2(first: 1000) {\n    edges {\n      node {\n        __typename\n        id\n        key\n        type\n        displayName\n        entityType\n        avaRef\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CustomFieldDefinitionEditModal_viewer_3HPvlA on Viewer {\n  customFieldDefinition(id: $customFieldId) {\n    __typename\n    id\n    key\n    type\n    displayName\n    entityType\n    avaRef\n    ... on TextCustomField {\n      readOnly\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a48e2e4703e2a148745afe5483da399a";

export default node;
